/**
 * The crew's calls, wordless: each member's avatar in the column under the
 * button they picked (DESIGN-CHANGELOG 2026-08-25).
 *
 * It replaced a labelled THE CREW band, and the whole idea is the alignment —
 * four equal columns with the vote strip's own 10px gap, so column two IS the
 * `A` button above it. That is what lets the letters go: a cluster had to
 * print `A` because it floated anywhere, and a column does not.
 *
 * AN EMPTY COLUMN IS A FACT, so all four render even when nobody picked that
 * call. The strip above is what names them; a column that vanished would shift
 * the ones beside it out from under their buttons and quietly turn "nobody
 * said C" into "there is no C".
 *
 * Renders nothing at all when the crew has made no calls: the count beside the
 * band heading already says `0 OF N CALLED`, and four empty columns under it
 * would be a grid of nothing.
 */

import { Avatar } from './Avatar.tsx';

export interface CallColumn {
  key: string;
  avs: Array<{
    key: string;
    ini: string;
    hueBg: string;
    hasAv: boolean;
    avBg: string;
    /** `DAVE — S · MUST PLAY`, composed by the view model. */
    title: string;
  }>;
}

export function CallColumns({ cols }: { cols: readonly CallColumn[] }): JSX.Element | null {
  if (!cols.some((c) => c.avs.length > 0)) return null;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 10 }}>
      {cols.map((col) => (
        <div
          key={col.key}
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            alignContent: 'flex-start',
            gap: 5,
          }}
        >
          {col.avs.map((v) => (
            <Avatar
              key={v.key}
              style={{ flex: 'none' }}
              size={20}
              fs={6}
              ini={v.ini}
              bg={v.hueBg}
              hasAv={v.hasAv}
              avBg={v.avBg}
              title={v.title}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
